import { z } from 'zod';

import { stringToUuidArray } from '../codecs';

export type ProcessingsQuery = z.output<typeof processingsQuerySchema>;
export type ProcessingsQueryDTO = z.input<typeof processingsQuerySchema>;

export const processingsQuerySchema = z.object({
  sessionIds: stringToUuidArray,
});
